<template>
  <div
    class="ui-sidebar-submenu-item submenu-item"
    :class="[
      { 'submenu-item-active': active, active, expandable },
      customClass,
    ]"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter.prevent="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <i :class="icon"></i>
    <span><slot>{{ label }}</slot></span>
    <ExpandArrowIcon v-if="expandable" :expanded="expanded" />
  </div>
</template>

<script>
import ExpandArrowIcon from './ExpandArrowIcon.vue';

export default {
  name: 'SidebarSubmenuItem',
  components: {
    ExpandArrowIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['click'],
  methods: {
    handleClick(event) {
      if (this.expandable) {
        event.stopPropagation();
      }
      this.$emit('click', event);
    },
  },
};
</script>

<style src="../styles/SidebarSubmenuItem.css"></style>
